export function dataURLToBlob(dataURL) {
  const byteString = atob(dataURL.split(",")[1]);
  const mimeString = dataURL
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return blob;
}

export function fileToBlob(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const dataURL = e.target.result;
      const blob = dataURLToBlob(dataURL);
      return resolve(blob);
    };
    reader.onerror = function(err) {
      return reject(err);
    };
    reader.readAsDataURL(file);
  });
}

export function fileFromJSON({ bits, name, options }) {
  const byteString = atob(bits.split(",")[1]);

  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], name, options);
}

export async function fileToJSON(file) {
  const bits = await new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = e => {
      resolve(e.target.result);
    };
    fileReader.onerror = err => {
      reject(err);
    };
    fileReader.readAsDataURL(file);
  });
  const name = file.name;
  const options = { type: file.type, lastModified: file.lastModified };
  return { bits, name, options };
}
